import React from 'react';
import ChoroplethMap from 'components/ChoroplethMap';
import mockHeatmapData from 'mocks/heatmap';
import './index.css';

const MapViewer = ({ onCountySelect: handleCountySelect, selectedCounty = {} }) => {
  return (
    <div
      style={{
        flex: 1,
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
      }}
      className="county-map-viewer"
      data-testid="map-viewer_root"
    >
      <ChoroplethMap
        onCountySelect={handleCountySelect}
        hoverColor="#0b3266"
        data={mockHeatmapData.countyFips}
        selectedCountyName={selectedCounty.name}
      />
    </div>
  );
};

export default MapViewer;
